module.exports = __webpack_public_path__ + "media/Video 55.c44ed3b6.mp4";